export default __webpack_public_path__ + "static/media/breadcrumbSeparator.2b867541.svg";